import { useMutation, useQuery, useQueryClient } from 'react-query'
import toast from 'react-hot-toast'

import { format, parseISO } from 'date-fns'

// import { useAuth } from '../contexts/AuthContext'
import { api } from '../utils/api'

const useSuperMid = ({ id }) => {
  const queryClient = useQueryClient()
  // const { checkAccessToken } = useAuth()

  const getSuperMidDraft = useQuery(
    ['getSuperMidDraft'],
    async () => {
      // await checkAccessToken()
      const { data } = await api.get(`/supermidpassdown/draft`)
      return data
    },
    {
      onError: (error) =>
        error?.response.data.errors.forEach((err) => {
          toast.error(err.msg)
        }),
    }
  )

  const patchSuperMidWetDraft = useMutation(
    async (values) => {
      if (values?.wetDate) {
        if (typeof values.wetDate == 'string') {
          values.wetDate = format(
            parseISO(values.wetDate),
            `yyyy-MM-dd'T'00:00:00.000-07:00`
          )
        } else {
          values.wetDate = format(
            values.wetDate,
            `yyyy-MM-dd'T'00:00:00.000-07:00`
          )
        }
      }

      const { data } = await api.patch(
        `/supermidpassdown/draft/wet/${id}`,
        values
      )
      return data
    },
    {
      onMutate: async (data) => {
        await queryClient.cancelQueries(['getSuperMidDraft'])
        const previousValue = queryClient.getQueryData(['getSuperMidDraft'])
        return previousValue
      },

      onError: (error, variables, previousValue) => {
        queryClient.setQueryData(['getSuperMidDraft'], previousValue)
        error?.response.data.errors.forEach((err) => {
          toast.error(err.msg)
        })
        toast.error(
          'Because of the previous error data has been reverted to the last saved state, please try again'
        )
      },
      onSuccess: (data) => {
        toast.success(`Success: Super Mid Wet Passdown ${data._id} updated`)
      },
      onSettled: () => {
        queryClient.invalidateQueries(['getSuperMidDraft'])
      },
    }
  )

  const patchSuperMidDryDraft = useMutation(
    async (values) => {
      if (values?.dryDate) {
        if (typeof values.dryDate == 'string') {
          values.dryDate = format(
            parseISO(values.dryDate),
            `yyyy-MM-dd'T'00:00:00.000-07:00`
          )
        } else {
          values.dryDate = format(
            values.dryDate,
            `yyyy-MM-dd'T'00:00:00.000-07:00`
          )
        }
      }

      const { data } = await api.patch(
        `/supermidpassdown/draft/dry/${id}`,
        values
      )
      return data
    },
    {
      onMutate: async (data) => {
        await queryClient.cancelQueries(['getSuperMidDraft'])
        const previousValue = queryClient.getQueryData(['getSuperMidDraft'])
        return previousValue
      },

      onError: (error, variables, previousValue) => {
        queryClient.setQueryData(['getSuperMidDraft'], previousValue)
        error?.response.data.errors.forEach((err) => {
          toast.error(err.msg)
        })
        toast.error(
          'Because of the previous error data has been reverted to the last saved state, please try again'
        )
      },
      onSuccess: (data) => {
        toast.success(`Success: Super Mid Dry Passdown ${data._id} updated`)
      },
      onSettled: () => {
        queryClient.invalidateQueries(['getSuperMidDraft'])
      },
    }
  )

  const postSuperMidEmailDraft = useMutation(
    async () => {
      const { data } = await api.post(`/supermidpassdown/draft/email`)
      return data
    },
    {
      onMutate: async (data) => {
        await queryClient.cancelQueries(['getSuperMidDraft'])
        const previousValue = queryClient.getQueryData(['getSuperMidDraft'])
        return previousValue
      },
      onError: (error, variables, previousValue) => {
        queryClient.setQueryData(['getSuperMidDraft'], previousValue)
        error?.response.data.errors.forEach((err) => {
          toast.error(err.msg)
        })
      },
      onSuccess: () => {
        toast.success(`Success: Supervisor Mid Shift Passdown Email sent`)
      },
      onSettled: () => {
        queryClient.invalidateQueries(['getSuperMidDraft'])
      },
    }
  )

  return {
    getSuperMidDraft,
    patchSuperMidWetDraft,
    patchSuperMidDryDraft,
    postSuperMidEmailDraft,
  }
}

export default useSuperMid
